module.exports = __webpack_public_path__ + "static/media/bat.ac04ec1f.svg";